import React from "react";
import Joi from "joi-browser";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { Tabs, Tab } from "react-bootstrap";
import {
  getVenue,
  addVenue,
  updateVenue,
} from "../../../common/services/markets/venueService";
import Form from "../../../common/components/form/form";
import Loading from "../../../common/components/loading/loading";
import VenueHistory from "./venueHistory";
import { withTranslation } from "react-i18next";

class Venue extends Form {
  state = {
    data: {
      venueId: "",
      name: "",
      description: "",
      timeZone: "",
      active: "",
      eventId: "",
    },
    createdDate: "",
    updatedDate: "",
    errors: {},
    isLoading: true,
    isNew: true,
  };

  schema = {
    venueId: Joi.string(),
    name: Joi.string().required().label(this.props.t("VenueName")),
    description: Joi.string()
      .required()
      .label(this.props.t("VenueDescription")),
    timeZone: Joi.string().required().label(this.props.t("TimeZone")),
    active: Joi.boolean().label(this.props.t("Active")),
    eventId: Joi.string(),
  };

  async componentDidMount() {
    //try{
    const { venueId, isNew } = this.props;
    this.setState({ isNew: isNew });
    var venue = {};

    if (!isNew) {
      venue = await getVenue(venueId);
      venue.eventId = uuid();
    } //New User Add
    else {
      venue = {
        venueId: venueId,
        name: "",
        description: "",
        timeZone: "",
        commoditiyClassId: "",
        active: true,
        eventId: uuid(),
      };
    }
    this.setState({ data: this.mapToViewModel(venue), isLoading: false });

    const dateFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      hour12: false,
      minute: "numeric",
      second: "numeric",
    };

    this.setState({
      createdDate: new Date(venue.createdDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
      updatedDate: new Date(venue.updatedDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
    });

    // }
    // catch(ex)
    // {
    //     //Handle Erorr..
    // }
  }

  mapToViewModel(venue) {
    return {
      venueId: venue.venueId,
      name: venue.name,
      description: venue.description,
      timeZone: venue.timeZone,
      active: venue.active,
      eventId: venue.eventId,
    };
  }

  doSubmit = async () => {
    const { t, onRename } = this.props;
    const { isNew } = this.state;

    try {
      //Reset the event ID
      const data = { ...this.state.data };
      data.eventId = uuid();
      this.setState({ data: data });

      if (!isNew) {
        await updateVenue(this.state.data);
        toast.success(t("VenueUpdated"));
      } else {
        await addVenue(this.state.data);
        this.setState({ isNew: false });
        onRename(this.state.data.venueId, this.state.data.name);
        toast.success(t("VenueAdded"));
      }

      //Call back to the select list to allow it to update.
      this.props.submitCallbackFunction(this.state.data);
    } catch (ex) {
      console.log(t("ErrorSaving"), ex);

      if (ex.response && ex.response.status === 400) {
        var errorList = ex.response.data.errors;
        if (errorList) {
          var errorKeys = Object.keys(ex.response.data.errors);
          errorKeys.forEach(function (key) {
            errorList[key].map((error) => {
              toast.error(t("ErrorSaving") + " " + key + ": " + error);
              return null;
            });
          });
        } else {
          toast.error(t("ErrorSaving") + " " + ex.response.data);
        }
        const errors = { ...this.state.errors };
        errors.Name = ex.response.data;
        toast.error(ex.response.data.errors.title);
        this.setState({ errors });
      }
    }
  };

  render() {
    const { isLoading, isNew, createdDate, updatedDate } = this.state;

    if (isLoading) return <Loading />;

    const { t, venueId, allowEdit } = this.props;

    const timeZones = Intl.supportedValuesOf("timeZone").map((x) => ({
      value: x,
      name:
        x +
        " (" +
        Intl.DateTimeFormat("us", {
          timeZoneName: "short",
          timeZone: x,
        })
          .formatToParts()
          .find((i) => i.type === "timeZoneName").value +
        ")",
    }));

    return (
      <div className="container-fluid">
        <form className="form-inline" onSubmit={this.handleSubmit}>
          <fieldset disabled={allowEdit ? "" : "disabled"}>
            <div>
              {this.renderSwitch("active", t("Active"))}
              {this.renderInput("name", t("VenueName"))}
              {this.renderInput("description", t("VenueDescription"))}
              {this.renderSelect(
                "timeZone",
                t("TimeZone"),
                timeZones,
                "value",
                "name"
              )}
              {allowEdit && this.renderButton(t("Save"))}
              <div className="form-footnote">
                {createdDate !== "Invalid Date" && (
                  <div>
                    {t("Created")} {createdDate}
                  </div>
                )}
                {updatedDate !== "Invalid Date" && (
                  <div>
                    {t("Updated")} {updatedDate}
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        </form>
        {!isNew && (
          <div>
            <Tabs
              className="nav-dark nav-tabs-sm"
              defaultActiveKey={1}
              id="useraccount-tabs"
              mountOnEnter={true}
              unmountOnExit={true}
            >
              <Tab eventKey={1} title={t("History")}>
                <VenueHistory venueId={venueId} />
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation(["markets"])(Venue);
